import { useMemo } from 'react';
import { useParams } from 'react-router';
import { useQuery } from '@apollo/client/react';
import { Button, Flex, Typography } from 'antd';

import AccountStatusTable from './AccountStatusTable';

import QueryBoundary from 'components/QueryBoundary/QueryBoundary';

import { useAccountLevelActions } from '../CreditAccountPage';
import { ACCOUNT_STATUSES_RAW } from 'queries/account';

const AccountStatusSection = () => {
  const { accountId, customerId } = useParams();
  const { applyStatusModal } = useAccountLevelActions();

  const accountStatusQuery = useQuery(ACCOUNT_STATUSES_RAW, {
    variables: { customerId: customerId, accountId },
  });

  const statuses = useMemo(
    () => accountStatusQuery.data?.account?.statusesRaw?.statuses,
    [accountStatusQuery.data],
  );

  return (
    <>
      <Typography.Title level={5}>Account Statuses</Typography.Title>
      <Flex justify="flex-end" style={{ marginBottom: 'var(--spacing) ' }}>
        <Button
          data-testid="apply-status-button"
          onClick={applyStatusModal.show}
        >
          Apply Status
        </Button>
      </Flex>
      <QueryBoundary
        query={accountStatusQuery}
        mode={QueryBoundary.MODE.MESSAGE}
        loadingMessage="Loading account statuses"
      >
        <AccountStatusTable statuses={statuses}></AccountStatusTable>
      </QueryBoundary>
    </>
  );
};

export default AccountStatusSection;
